module.exports = __webpack_public_path__ + "img/icon7.2d71e137.png";